import './rounding.scss';

import roundSvg_1 from '~shared/assets/icons/round_gray.svg';
import roundSvg_2 from '~shared/assets/icons/round_green.svg';

export const RoundingGraph = () => {
	return (
		<div className="rounding-graph">
			<div className="rounding-graph__left">
				<div className="rounding-graph__title">
					<p>Отклонение на приход пораньше</p>
					<p style={{ color: '#1dbf73', textAlign: 'right' }}>Отклонение на приход позже</p>
				</div>
				<div className="rounding-graph__img">
					<img src={roundSvg_1} alt="" />
					<img src={roundSvg_2} alt="" />
				</div>
			</div>
			<div className="rounding-graph__right">
				<div className="rounding-graph__title">
					<p style={{ color: '#1dbf73' }}>Отклонение на уход пораньше</p>
					<p style={{ textAlign: 'right' }}>Отклонение на уход позже</p>
				</div>
				<div style={{ justifyContent: 'flex-end' }} className="rounding-graph__img">
					<img src={roundSvg_2} alt="" />
					<img src={roundSvg_1} alt="" />
				</div>
			</div>
		</div>
	);
};
